export const DEFAULT_FEES = { fm_rate: "12", rc_rate: "8", lo_rate: "7", arrangement_fee: "180" };

export const SERVICE_RATE_KEY = { "Full Management": "fm_rate", "Rent Collection": "rc_rate", "Let Only": "lo_rate" };

export const pct = (v) => `${v}% + VAT`;

export const arrangementLabel = (fees, service) => {
  if (service === "Full Management") return "Arrangement fee included";
  const a = String(fees.arrangement_fee ?? "").trim();
  return a === "" || a === "0" ? "No arrangement fee" : `£${a} arrangement fee`;
};

export const rateFor = (fees, service) => pct(fees[SERVICE_RATE_KEY[service]]);
